module.exports = __webpack_public_path__ + "media/assets/images/logos/kitchen_c3_logo-a0db916da1da7625aa792daab7d70c6e.svg";